import styled from "styled-components";
import { 
  Form as AntForm, 
  Typography as AntTypography,
  Input as AntInput,
  Button as AntButton,
} from "antd";
import { BackArrow } from '@assets';
import { AuthBg, AuthLogo } from "@assets/auth";
import lightTheme from '@styles/theme';

export const RootContainer = styled.div`
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  flex-direction: column;
  background-image: url(${AuthBg});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 0px 16px;

  .ant-form-item-explain {
    text-align: left; /* align warning text to the left */
    margin-left: 8px;
  }

  .ant-btn-primary {
    width: 100%;
    height: 56px;
  }

  #login-btn {
    margin-bottom: 30px;
  }
`;

export const NavContainer = styled.div`
  display: flex;
  width: 100%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-top: 16px;
`;

export const ArrowIconWrapper = styled.div`
  width: 37px;
  height: 37px;
  background-color: ${lightTheme.appbarColor};
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 7px;
  cursor: pointer;
`
export const BackIcon = styled(BackArrow)`
  width: 25px;
  height: 25px;
`;

export const SkipButton = styled(AntButton)`
  display: inline-flex;
  padding: 7px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  background-color: #212224;

  color: #FFB829;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
`
export const Logo = styled(AuthLogo)`
  margin: 36px 0 0 0;
`

export const ContentContainer = styled.div`
  width: 100%;
  margin: 39px auto 24px;
`

export const Title = styled(AntTypography.Title)`
margin: 0 !important;
  color: #FFC654 !important;
  text-align: center;
  font-size: 20px !important;
  font-style: normal;
  font-weight: 500 !important;
  line-height: normal !important;
` 

export const Form = styled(AntForm)`
  margin-top: 30px;
  width: 100%;
  text-align: center;

  .ant-form-item {
    margin-bottom: 24px;
  }

  .ant-form-item:last-child {
    margin-bottom: 0 !important;
  }

  .ant-form-item-label {
    margin: 0px 0 2px 8px;
    text-align: left;
    padding: 0 !important;
  }

  .ant-form-item-label label {
    color: #DADADA;
    font-size: 16px;
    font-style: normal;
    font-weight: 100;
    line-height: normal;
  }

  .ant-input-affix-wrapper {
    height: 52px;
    border: 1px solid #e1cce0;
    border-radius: 10px;
  }

  input {
    height: 56px;
    border: 1px solid #e1cce0;
  }

  .ant-btn-primary {
    margin-top: 8px;
  }
`;

export const Input = styled(AntInput)`
  -moz-appearance: textfield;
;
  color: #0E1017 !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  text-align: left;
  padding-left: 15px;
  border-radius: 12px;

  &::placeholder {
    margin-left: 2px;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    color: #BFBFBF; 
  }
  appearance: textfield;
  ::-webkit-inner-spin-button,
  ::-webkit-outer-spin-button {
    -webkit-appearance: none; /* WebKit */
    margin: 0;
  }
  ::-webkit-inner-spin-button:disabled,
  ::-webkit-outer-spin-button:disabled {
    display: none;
  }

  &:focus{
    border: 2px solid #FFC654;
  }
`;

export const BottomText = styled.div`
  font-size: 14px;
  font-weight: normal;
  color: #ffffff;
  margin-bottom: 30px;
`;

export const Link = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: ${(props) => props.theme.primaryColor};
  cursor: pointer;
`;

export const ORText = styled.div`
  margin: 0 auto 23px !important;
  text-align: center;
  color: #FFF;
  font-size: 16px;
  font-style: normal;
  font-weight: 100;
  line-height: normal;
`

export const PromoRegisterButton = styled(AntButton)`
  background-color: transparent !important;
  border: 2px solid #CC9321;
  border-radius: 12px;
  margin: 23px 0;
  color: #FFF;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;

  &:hover {
    background: transparent !important;
    color: white !important;
  }
`

export const GoogleLoginButton = styled.div`
margin-top: 24px;
margin-bottom: 24px;
width: 100%;
height: 52px;
border-radius: 10px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background-color: #fff;
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;


export const SpaceBetweenTopBottom = styled.div`
margin-top: 24px;
margin-bottom: 24px;
width:100%;
`;

export const SocialRegisterWrapper = styled.div`
display:flex;
width:100%;
gap:20px;
align-items:center
`;

export const TelegramRegisterButton = styled.div`
margin-top: 24px;
margin-bottom: 24px;
width: 100%;
height: 52px;
border-radius: 10px;
display: flex;
gap: 10px;
align-items: center;
justify-content: center;
background-color: #fff;
cursor: pointer;
position: relative;

font-size: 14px;
font-weight: bold;

svg {
  width: 24px;
}

.ant-spin {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
`;